import React  from 'react';
import CategoryCard from '../CategoryCard/CategoryCard';
import CTA from '../CTA/CTA';
import { useQuery } from "react-query";
import Advertisement from '../Advertisement/Advertisement';
import Spinner from '../../../Component/Spinner/Spinner';
import Banners from '../Banner/Banners';
import './Home.css';
import Service from '../Service/Service';

const Home = () => {

    const {
        data: categories = [],
        refetch,
    } = useQuery({
        queryKey: ["categories"],
        queryFn: async () => {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/category`
            );
            const data = await res.json();
            if (data.success) {
                return data.data;
            } else {
                return [];
            }
        },
    });

    const { data: advertise = [], isLoading} = useQuery({
        queryKey: ['advertise'],
        queryFn: async () => {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/products/advertisement`)
            const data = res.json();
            return data;
        }
    })

if(isLoading){
return <Spinner/>
}

    return (
        <>
            <Banners/>
            {
                   <Advertisement advertise={advertise}/>
            }
            <section className='TopCate background'>
                <div className='container'>
                    <div className='heading d_flex'>
                        <div className='heading-left row  f_flex'>
                            <i className='fa-solid fa-border-all'></i>
                            <h2>Top Categories</h2>
                        </div>
                    </div>
                    <div className='grid2'>
                        {
                            categories.map(categories => <CategoryCard key={categories._id} categories={categories} />)
                        }
                    </div>
                </div>
            </section>
            <Service/>
            <CTA/>
        </>
    );
};

export default Home;